<template>
    <div class="col-12">
        <div class="row">
            <b-overlay :show="loading" class="content">
                <div class="mb-3 text-center">
                    <hr />
                    <strong> تراکنش های فروشگاه {{ shopName }}</strong>
                    <hr />
                </div>
                <div class="w-100 mb-3 float-left">
                    <button type="button"
                            class="btn btn-light text-right"
                            @click="showFilters = true">
                        <font-awesome-icon class="mr-2 ml-2" icon="sliders-h" /> تنظیمات صفحه
                    </button>
                    <button type="button"
                            class="btn btn-light text-right"
                            @click="getExport">
                        <font-awesome-icon class="mr-2 ml-2" icon="file-export" /> دریافت خروجی اکسل
                    </button>
                </div>
                <table v-if="screenWidth > 1021"
                       class="table table-bordered bg-white table-striped text-center">
                    <thead>
                        <tr>
                            <th v-for="field in fields" v-if="field.showCell" :key="field.key">
                                {{ $t("param." + field.key) }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in items">
                            <td v-for="field in fields" v-if="field.showCell">
                                <span v-if="field.key == 'record'">
                                    {{ index + (currentPage - 1) * perPage + 1 }}
                                </span>
                                <span v-else-if="field.key == 'actions'">
                                    <button class="btn btn-light btn-sm m-1"
                                            @click="onShowDatails(item)">
                                        جزئیات
                                    </button>
                                </span>
                                <span v-else v-bind:class="{ 'card-number': field.cardNumber }">
                                    {{field.money ? new Intl.NumberFormat().format(item[field.key]) : item[field.key] }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table v-if="screenWidth < 1024"
                       v-for="(item, index) in items"
                       class="table table-light shadow-sm table-silver text-right" v-bind:class="{'table-silver': (index % 2 > 0)}">
                    <tr v-for="field in fields" v-if="field.showCellMobile">
                        <th>
                            {{ $t("param." + field.key) }}
                        </th>
                        <td>
                            <span v-if="field.key == 'record'">
                                {{ index + (currentPage - 1) * perPage + 1 }}
                            </span>
                            <span v-if="field.key == 'actions'">
                                <button class="btn btn-outline-dark btn-sm2 m-1"
                                        @click="onShowDatails(item)">
                                    جزئیات
                                </button>
                            </span>
                            <span v-else v-bind:class="{ 'card-number': field.cardNumber }">
                                {{field.money ? new Intl.NumberFormat().format(item[field.key]) : item[field.key] }}
                            </span>
                        </td>
                    </tr>
                </table>

                <b-pagination dir="ltr"
                              pills
                              @input="initTable"
                              v-model="currentPage"
                              :total-rows="totalFilteredRows"
                              :per-page="perPage"
                              size="sm"></b-pagination>
            </b-overlay>
        </div>
        <b-modal centered hide-footer v-model="showDetails">
            <div class="text-center">
                <strong class="d-block mb-3">
                    {{ $t("view.club.transactionDetails") }}
                </strong>
                <table class="table text-center table-sm table-light">
                    <tr v-for="field in fields" v-if="field.shotDetails">
                        <th>{{ $t("param." + field.key) }}</th>
                        <td>
                            {{field.money ? new Intl.NumberFormat().format(selected[field.key]) : selected[field.key] }}
                        </td>
                    </tr>
                </table>
            </div>
        </b-modal>
        <b-modal size="lg" hide-footer v-model="showFilters">
            <div class="col-12">
                <div class="row">
                    <div class="col-12 col-md-7 float-right">
                        <table class="table table-borderless text-right">
                            <tr>
                                <td>{{ $t("param.table.perPage") }}</td>
                                <td>
                                    <b-form-select :options="perPageOptions"
                                                   class="form-control"
                                                   v-model="perPageSelectedOption"></b-form-select>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t("param.table.fromDate") }}</td>
                                <td>
                                    <date-picker color="#f5c842"
                                                 v-model="fromDate"
                                                 :clearable="true" />
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t("param.table.toDate") }}</td>
                                <td>
                                    <date-picker color="#f5c842"
                                                 v-model="toDate"
                                                 :clearable="true" />
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-12 col-md-5 float-right">
                        <table class="table text-right table-light">
                            <tr v-for="(field, index) in fields" v-if="field.shotDetails">
                                <th>{{ $t("param." + field.key) }}</th>
                                <td>
                                    <b-form-checkbox switch
                                                     v-model="fields[index].showCell"
                                                     size="lg"></b-form-checkbox>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <button class="btn btn-outline-dark" @click="initFilters">
                        اعمال تنظیمات
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>

    import XLSX from 'xlsx';

    export default {
        props: {
            shopId: 0
        },
        data()
        {
            return {
                screenWidth: null,
                loading: false,
                showFilters: false,
                showSplits: false,
                showDetails: false,
                shopName: '',
                selected: {},
                items: [],
                fields: [
                    {
                        key: "record",
                        showCell: true,
                        shotDetails: false,
                        excel: false
                    },
                    {
                        key: "transactionId",
                        showCell: false,
                        shotDetails: false,
                        excel: true
                    },
                    {
                        key: "cardHolderCardNumber",
                        showCell: true,
                        shotDetails: true,
                        cardNumber: true,
                        excel: true
                    },
                    {
                        key: "clientTerminal",
                        showCell: false,
                        shotDetails: true,
                        excel: true
                    },
                    {
                        key: "transactionValue",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: true,
                        money: true,
                        excel: true
                    },
                    {
                        key: "splitCount",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: true,
                        excel: true
                    },
                    {
                        key: "ramnicWagePercent",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: true,
                        excel: true
                    },
                    {
                        key: "shopName",
                        showCell: false,
                        showCellMobile: false,
                        shotDetails: true,
                        excel: true
                    },
                    {
                        key: "transactionPersianDate",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: true,
                        excel: true
                    },
                    {
                        key: "transactionTime",
                        showCell: true,
                        shotDetails: true,
                        excel: true
                    },
                    {
                        key: "shopAddress",
                        showCell: false,
                        shotDetails: true,
                        excel: true
                    },
                    {
                        key: "actions",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: false
                    }
                ],
                fromDate: null,
                toDate: null,
                totalRows: 1,
                totalFilteredRows: 1,
                currentPage: 1,
                perPage: 10,
                perPageSelectedOption: "10",
                perPageOptions: [
                    { text: 10, value: 10 },
                    { text: 50, value: 50 },
                    { text: 100, value: 100 },
                    { text: 500, value: 500 },
                    { text: 1000, value: 1000 },
                    { text: 5000, value: 5000 },
                ]
            };
        },

        beforeMount()
        {
            this.screenWidth = window.outerWidth;
            this.initTable();
        },

        mounted()
        {
            this.totalRows = this.items.length;
        },

        methods: {


            getExport()
            {
                var header = [], items = [];

                for (var field of this.fields)
                {
                    if (field.excel)
                    {
                        header.push(this.$t("param." + field.key))
                    }
                }

                items.push(header)

                for (var item of this.items)
                {
                    var itemArr = [];
                    for (var field of this.fields)
                    {
                        if (field.excel)
                        {
                            itemArr.push(item[field.key])
                        }
                    }

                    items.push(itemArr)
                }

                var wb = XLSX.utils.book_new();

                wb.Workbook = {
                    Views: [{ RTL: true }]
                }

                var ws = XLSX.utils.json_to_sheet(items, { skipHeader: true });
                XLSX.utils.book_append_sheet(wb, ws, 'sheet1');
                XLSX.writeFile(wb, 'export' + '.xlsx');
            },

            initFilters()
            {
                this.showFilters = false;
                this.perPage = Number(this.perPageSelectedOption);
                this.initTable();
            },

            initTable()
            {
                this.loading = true;

                const data = {
                    Search: "",
                    Start: (this.currentPage - 1) * this.perPage,
                    Length: this.perPage,
                    FromDate: this.fromDate,
                    ToDate: this.toDate,
                    ShopID: this.shopId
                };

                axios({ method: "post", url: "/api/app/GetShopTransactions", data: data })
                    .then(response =>
                    {
                        this.items = response.data.meta.transactions;
                        this.totalRows = response.data.meta.totalRows;
                        this.totalFilteredRows = response.data.meta.totalFilteredRows;
                        this.shopName = response.data.meta.shopName;
                        this.loading = false;
                    })
                    .catch(error => { });
            },

            onShowDatails(item)
            {
                this.selected = item;
                this.showDetails = true;
            },

            onShowSplits(item)
            {
                this.selected = item;
                this.showSplits = true;
            },

            getPath()
            {
                return "fsadfdsf";
            }
        }
    };
</script>
<style>
    .card-number {
        display: inline-block;
        direction: ltr;
    }
</style>
